import React from 'react';
import { Typography } from '@fiverr-private/typography';
import { useFormContext } from '../FormContext';
import type { FormTextHelper } from '../types';
import { FORM_HELPER_TEXT_ID } from '../constants';
import { getValidationColor } from '../FormControl/helpers';
import { getMessage, getEmptyLines } from './helpers';

const FormHelperText = ({
  error,
  isError: isErrorProp,
  isSuccess: isSuccessProp,
  emptyLines,
  dataTrackTag = 'form_helper_text',
  dataTrackValue,
  ...restProps
}: FormTextHelper) => {
  const { isError, isSuccess, error: formError } = useFormContext();
  const isErrorInternal = isErrorProp || isError;
  const isSuccessInternal = isSuccessProp || isSuccess;
  const message = getMessage({
    isError: isErrorInternal,
    isSuccess: isSuccessInternal,
    error: error || formError,
    ...restProps,
  });
  const color = getValidationColor({ isError: isErrorInternal, isSuccess: isSuccessInternal });

  if (message) {
    return (
      <Typography dataTrackTag={dataTrackTag} dataTrackValue={dataTrackValue} color={color}>
        {message}
      </Typography>
    );
  }

  return getEmptyLines(emptyLines);
};

FormHelperText.id = FORM_HELPER_TEXT_ID;
FormHelperText.displayName = FORM_HELPER_TEXT_ID;

export default FormHelperText;
